import { DataItemType, FormControlType } from "../../../schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-input-date.vue";
import mobile from "./components/mobile-input-date.vue";
const info = {
    title: "日期",
    title_i18n: "{\"zh\": \"日期\", \"en\": \"Date\"}",
    type: "calendar",
    icon: "h-icon-all-calendar-o",
    dataItemType: DataItemType.Date,
    formControllerType: FormControlType.Date,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
